import { render } from "./ReferidosPrimerNivel.vue?vue&type=template&id=0a7006c5&scoped=true"
import script from "./ReferidosPrimerNivel.vue?vue&type=script&lang=js"
export * from "./ReferidosPrimerNivel.vue?vue&type=script&lang=js"

import "./ReferidosPrimerNivel.vue?vue&type=style&index=0&id=0a7006c5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7006c5"]])

export default __exports__